import { createRouter, createWebHashHistory } from 'vue-router'
import index from '../views/index.vue'
import Home from '@/components/Home.vue'
import Design from '@/components/Design.vue'
import SameDesign from '@/components/SameDesign.vue'
import Restore from '@/components/Restore.vue'
import Cases from '@/components/Cases.vue'
import Contact from '@/components/Contact.vue'
import LoginRegister from '@/views/LoginRegister.vue'
import CategoryManagement from '@/components/CategoryManagement.vue'
import CategoryEdit from '@/components/CategoryEdit.vue'
import Mall from '@/components/Mall.vue'
import ClothingStore from '@/components/ClothingStore.vue'
import Recharge from '@/views/Recharge.vue'
import ImageBrief from '@/components/ImageBrief.vue'


const routes = [
  {
    path: '/',
    component: index,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: 'design',
        name: 'design',
        component: Design
      },
      {
        path: 'restore',
        name: 'restore',
        component: Restore
      },
      {
        path: 'cases',
        name: 'cases',
        component: Cases
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact
      },
      {
        path: 'same-design',
        name: 'same-design',
        component: SameDesign
      },
      {
        path: 'category',
        name: 'category',
        component: CategoryManagement
      },
       {
        path: 'mall',
        name: 'mall',
        component: Mall
      },
      {
        path: 'clothing',
        name: 'clothing',
        component: ClothingStore
      },
      {
        path: 'category/edit/:id',
        name: 'category-edit',
        component: CategoryEdit
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: Recharge
      },
      {
        path: 'image-brief',
        name: 'image-brief',
        component: ImageBrief
      }
    ]
  },
  {
    path:'/login',
    name:'login',
    component:LoginRegister
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router